import { Component, OnInit, HostListener } from '@angular/core'
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';

// Services
import { ControllerService } from '../../../services/controller/controller.service';
import { LanguageService } from '../../../services/language/language.service';

// Images
import { Certifications, Funding, Partners } from '../../../constants/image-lists';

// References
import { ConstantStrings } from '../../../constants/constant-strings'





@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    MatButtonModule,
    CommonModule
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css'
})
export class LandingPageComponent implements OnInit {

  ItemList_partners:any = Partners
  ItemList_certifications:any = Certifications
  ItemList_funding:any = Funding

  ReferecesDict:any = ConstantStrings.externalRefereces

  /* 
  Se ha marcado el servicio "controllerService" como "readonly", porque se inyectan en el 
  constructor y no se vuelven a modificar. Esto es una buena práctica.
  */
  constructor(
    private readonly controllerService:ControllerService,
    public languageService:LanguageService,
  ) { }


  ngOnInit(): void {
    // Set min height to the main panel element so its cover the entire screen
    this.setMainpanelMinHeight()
      // Scroll to the top every time the page is loaded
      window.scrollTo(0,0)
  }


  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    // Set min height to the main panel element so its cover the entire screen
    this.setMainpanelMinHeight()
  }



  setMainpanelMinHeight(){
    const element = document.getElementById('main-panel')!;
    element.style.minHeight = window.innerHeight.toString()+'px'; 
  }
  
  navigate(route:string){
    this.controllerService.navigate(route)
  }

  
  referenceClicked(refereceId:string){
    window.open(this.ReferecesDict[refereceId], "_blank");

  }

  itemClicked(item:any){
    if(item.url.length == 0) return
    window.open(item.url, "_blank");
  }

  onItemKeyDown(event: KeyboardEvent, item: any): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.itemClicked(item);
    }
  }
  
  

}
